var localConfig = {
  b2cApiHost: 'https://api-b2c-prod.tryoliver.com',
  apiHost: 'https://api-prod.tryoliver.com',
  sGmapUrl: 'https://maps.googleapis.com/maps/api/staticmap',
  statics: 'https://statics.oliversports.ai',
  gmapKey: 'AIzaSyCKONuYPgvNtIyvxrIwdTYgvEs5rOHPNvA',
  defaultGMapZoom: 18,
  env: 'prod',
  cookieDomain: '',
  sessionTimeout: 60,
  today: new Date(),
  gtm: 'GTM-WVPM7CW',
  heatmap: {
    host: 'https://stats-prod.oliversports.ai/',
    token: 'a4561057adf2f313ce1e93fc33cc06bf'
  },
  aws: {
    s3: {
      host: 'https://oliver-platform-assets.s3-us-west-2.amazonaws.com'
    }
  },
  intercom: {
    workspace: 'h8nfatiq',
  }
};
/* jQuery Storage API Plugin 1.7.3 https://github.com/julien-maurel/jQuery-Storage-API */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e("object"==typeof exports?require("jquery"):jQuery)}(function(e){function t(t){var r,i,n,o=arguments.length,s=window[t],a=arguments,u=a[1];if(2>o)throw Error("Minimum 2 arguments must be given");if(e.isArray(u)){i={};for(var f in u){r=u[f];try{i[r]=JSON.parse(s.getItem(r))}catch(c){i[r]=s.getItem(r)}}return i}if(2!=o){try{i=JSON.parse(s.getItem(u))}catch(c){throw new ReferenceError(u+" is not defined in this storage")}for(var f=2;o-1>f;f++)if(i=i[a[f]],void 0===i)throw new ReferenceError([].slice.call(a,1,f+1).join(".")+" is not defined in this storage");if(e.isArray(a[f])){n=i,i={};for(var m in a[f])i[a[f][m]]=n[a[f][m]];return i}return i[a[f]]}try{return JSON.parse(s.getItem(u))}catch(c){return s.getItem(u)}}function r(t){var r,i,n=arguments.length,o=window[t],s=arguments,a=s[1],u=s[2],f={};if(2>n||!e.isPlainObject(a)&&3>n)throw Error("Minimum 3 arguments must be given or second parameter must be an object");if(e.isPlainObject(a)){for(var c in a)r=a[c],e.isPlainObject(r)?o.setItem(c,JSON.stringify(r)):o.setItem(c,r);return a}if(3==n)return"object"==typeof u?o.setItem(a,JSON.stringify(u)):o.setItem(a,u),u;try{i=o.getItem(a),null!=i&&(f=JSON.parse(i))}catch(m){}i=f;for(var c=2;n-2>c;c++)r=s[c],i[r]&&e.isPlainObject(i[r])||(i[r]={}),i=i[r];return i[s[c]]=s[c+1],o.setItem(a,JSON.stringify(f)),f}function i(t){var r,i,n=arguments.length,o=window[t],s=arguments,a=s[1];if(2>n)throw Error("Minimum 2 arguments must be given");if(e.isArray(a)){for(var u in a)o.removeItem(a[u]);return!0}if(2==n)return o.removeItem(a),!0;try{r=i=JSON.parse(o.getItem(a))}catch(f){throw new ReferenceError(a+" is not defined in this storage")}for(var u=2;n-1>u;u++)if(i=i[s[u]],void 0===i)throw new ReferenceError([].slice.call(s,1,u).join(".")+" is not defined in this storage");if(e.isArray(s[u]))for(var c in s[u])delete i[s[u][c]];else delete i[s[u]];return o.setItem(a,JSON.stringify(r)),!0}function n(t,r){var n=a(t);for(var o in n)i(t,n[o]);if(r)for(var o in e.namespaceStorages)u(o)}function o(r){var i=arguments.length,n=arguments,s=(window[r],n[1]);if(1==i)return 0==a(r).length;if(e.isArray(s)){for(var u=0;u<s.length;u++)if(!o(r,s[u]))return!1;return!0}try{var f=t.apply(this,arguments);e.isArray(n[i-1])||(f={totest:f});for(var u in f)if(!(e.isPlainObject(f[u])&&e.isEmptyObject(f[u])||e.isArray(f[u])&&!f[u].length)&&f[u])return!1;return!0}catch(c){return!0}}function s(r){var i=arguments.length,n=arguments,o=(window[r],n[1]);if(2>i)throw Error("Minimum 2 arguments must be given");if(e.isArray(o)){for(var a=0;a<o.length;a++)if(!s(r,o[a]))return!1;return!0}try{var u=t.apply(this,arguments);e.isArray(n[i-1])||(u={totest:u});for(var a in u)if(void 0===u[a]||null===u[a])return!1;return!0}catch(f){return!1}}function a(r){var i=arguments.length,n=window[r],o=arguments,s=(o[1],[]),a={};if(a=i>1?t.apply(this,o):n,a._cookie)for(var u in e.cookie())""!=u&&s.push(u.replace(a._prefix,""));else for(var f in a)s.push(f);return s}function u(t){if(!t||"string"!=typeof t)throw Error("First parameter must be a string");g?(window.localStorage.getItem(t)||window.localStorage.setItem(t,"{}"),window.sessionStorage.getItem(t)||window.sessionStorage.setItem(t,"{}")):(window.localCookieStorage.getItem(t)||window.localCookieStorage.setItem(t,"{}"),window.sessionCookieStorage.getItem(t)||window.sessionCookieStorage.setItem(t,"{}"));var r={localStorage:e.extend({},e.localStorage,{_ns:t}),sessionStorage:e.extend({},e.sessionStorage,{_ns:t})};return e.cookie&&(window.cookieStorage.getItem(t)||window.cookieStorage.setItem(t,"{}"),r.cookieStorage=e.extend({},e.cookieStorage,{_ns:t})),e.namespaceStorages[t]=r,r}function f(e){if(!window[e])return!1;var t="jsapi";try{return window[e].setItem(t,t),window[e].removeItem(t),!0}catch(r){return!1}}var c="ls_",m="ss_",g=f("localStorage"),h={_type:"",_ns:"",_callMethod:function(e,t){var r=[this._type],t=Array.prototype.slice.call(t),i=t[0];return this._ns&&r.push(this._ns),"string"==typeof i&&-1!==i.indexOf(".")&&(t.shift(),[].unshift.apply(t,i.split("."))),[].push.apply(r,t),e.apply(this,r)},get:function(){return this._callMethod(t,arguments)},set:function(){var t=arguments.length,i=arguments,n=i[0];if(1>t||!e.isPlainObject(n)&&2>t)throw Error("Minimum 2 arguments must be given or first parameter must be an object");if(e.isPlainObject(n)&&this._ns){for(var o in n)r(this._type,this._ns,o,n[o]);return n}var s=this._callMethod(r,i);return this._ns?s[n.split(".")[0]]:s},remove:function(){if(arguments.length<1)throw Error("Minimum 1 argument must be given");return this._callMethod(i,arguments)},removeAll:function(e){return this._ns?(r(this._type,this._ns,{}),!0):n(this._type,e)},isEmpty:function(){return this._callMethod(o,arguments)},isSet:function(){if(arguments.length<1)throw Error("Minimum 1 argument must be given");return this._callMethod(s,arguments)},keys:function(){return this._callMethod(a,arguments)}};if(e.cookie){window.name||(window.name=Math.floor(1e8*Math.random()));var l={_cookie:!0,_prefix:"",_expires:null,_path:null,_domain:null,setItem:function(t,r){e.cookie(this._prefix+t,r,{expires:this._expires,path:this._path,domain:this._domain})},getItem:function(t){return e.cookie(this._prefix+t)},removeItem:function(t){return e.removeCookie(this._prefix+t)},clear:function(){for(var t in e.cookie())""!=t&&(!this._prefix&&-1===t.indexOf(c)&&-1===t.indexOf(m)||this._prefix&&0===t.indexOf(this._prefix))&&e.removeCookie(t)},setExpires:function(e){return this._expires=e,this},setPath:function(e){return this._path=e,this},setDomain:function(e){return this._domain=e,this},setConf:function(e){return e.path&&(this._path=e.path),e.domain&&(this._domain=e.domain),e.expires&&(this._expires=e.expires),this},setDefaultConf:function(){this._path=this._domain=this._expires=null}};g||(window.localCookieStorage=e.extend({},l,{_prefix:c,_expires:3650}),window.sessionCookieStorage=e.extend({},l,{_prefix:m+window.name+"_"})),window.cookieStorage=e.extend({},l),e.cookieStorage=e.extend({},h,{_type:"cookieStorage",setExpires:function(e){return window.cookieStorage.setExpires(e),this},setPath:function(e){return window.cookieStorage.setPath(e),this},setDomain:function(e){return window.cookieStorage.setDomain(e),this},setConf:function(e){return window.cookieStorage.setConf(e),this},setDefaultConf:function(){return window.cookieStorage.setDefaultConf(),this}})}e.initNamespaceStorage=function(e){return u(e)},g?(e.localStorage=e.extend({},h,{_type:"localStorage"}),e.sessionStorage=e.extend({},h,{_type:"sessionStorage"})):(e.localStorage=e.extend({},h,{_type:"localCookieStorage"}),e.sessionStorage=e.extend({},h,{_type:"sessionCookieStorage"})),e.namespaceStorages={},e.removeAllStorages=function(t){e.localStorage.removeAll(t),e.sessionStorage.removeAll(t),e.cookieStorage&&e.cookieStorage.removeAll(t),t||(e.namespaceStorages={})}});
(function($) {
  $(document).ready(function() {
    var endpoint = localConfig.apiHost + '/v1/auth/',
      ns = $.initNamespaceStorage('OLIVER-Platform.session');

    var session = ns.localStorage.get();
    var backUrl = '/#/login?p=' + Date.now();
    var siteRCKey = '6LcJvd4UAAAAAEH8Xvb4Bv0IJYRzS8oq_D0FOn2a';
    var availableLangs = ['es', 'en', 'pt', 'ja'];
    var userLang = 'es';

    if (session && session.user && session.user.language) {
      userLang = session.user.language.slice(0, 2);
    } else if (window.navigator.language) {
      userLang = window.navigator.language.slice(0, 2);
    }

    if (availableLangs.indexOf(userLang) === -1) {
      userLang = 'en';
    }

    var postMessage = function(wName, msg) {
      if (window[wName]) {
        window[wName].postMessage(msg);
      }
    }

    var translations = {
      es: {
        'page_title': 'Accede a tu cuenta | Oliver Platform',
        'page_description': 'Ingresá con tu usuario y contraseña y medí todas tus métricas de los partidos has jugado. Saca tu potencial al máximo con OLIVER.',
        'invalid_user_pass': 'Nombre de Usuario o Contraseña Incorrectas',
        'userNotFound': 'Nombre de Usuario o Contraseña Incorrectas',
        'reset_max_tries': 'Has alcanzado la máxima cantidad de intentos diarios',
        'reset_not_found': 'No se encontró ningun usuario con los datos ingresados',
        'ask_demo': 'solicitar una demo',
        'form_email_username': 'Email / Nombre de Usuario',
        'form_password': 'Contraseña',
        'have_you_forgot': '¿Has olvidado tu',
        'form_username': 'Usuario',
        'form_login': 'Ingresar',
        'form_accept': 'Aceptar',
        'form_email': 'Correo Electrónico',
        'dont_have_account': '¿No tienes cuenta?',
        'contact_us': 'Contactanos',
        'reset_password': 'Restablecer Contraseña',
        'form_reset': 'Restablecer',
        'form_recover': 'Recuperar',
        'forgot_success_1': 'El Correo para restablecer la contraseña ha sido enviado',
        'forgot_success_2': 'Se envió un mensaje a tu correo electrónico',
        'forgot_success_3': 'Sigue las instrucciones para restablecer la contraseña.',
        'forgot_success_4': 'Si no recives el correo, revisa el correo no deseado o spam',
        'recover_username': 'Recuperar Usuario',
        'forgot_user_success_1': 'El Correo para restablecer el usuario ha sido enviado',
        'forgot_user_success_2': 'Se envió un mensaje a tu correo electrónico',
        'player_without_access': 'El Club al que perteneces ha deshabilitado el acceso para jugadores.',
        'playerAccessDisabled': 'El Club al que perteneces ha deshabilitado el acceso para jugadores.',
        'clubDisabled': 'El Club y sus integrantes han sido momentáneamente bloqueados.',
        'error_423': 'Ha intentado iniciar sesión demasiadas veces, por ese motivo tu cuenta se encuentra temporalmente bloqueada. Vuelve a intentarlo en {{mins}} minutos.'
      },
      en: {
        'page_title': 'Access your account | Oliver Platform',
        'page_description': 'Log in with your username and password and measure all your metrics of the matches you have played. Get your full potential with OLIVER.',
        'invalid_user_pass': 'Invalid Username or Password',
        'userNotFound': 'Invalid Username or Password',
        'reset_max_tries': 'You have reached the maximum number of daily attempts',
        'reset_not_found': 'No user was found with the data entered',
        'ask_demo': 'Ask for a Demo',
        'form_email_username': 'Email / Username',
        'form_password': 'Password',
        'have_you_forgot': 'Have you forgotten your',
        'form_username': 'Username',
        'form_login': 'Login',
        'form_accept': 'Accept',
        'form_email': 'Email',
        'dont_have_account': 'Don\'t you have an account?',
        'contact_us': 'Contact Us',
        'reset_password': 'Reset Password',
        'form_reset': 'Reset',
        'form_recover': 'Recover',
        'forgot_success_1': 'An email to reset the password has been sent',
        'forgot_success_2': 'A message was sent to your email',
        'forgot_success_3': 'Follow the instructions to reset the password.',
        'forgot_success_4': 'If you donn\'t get any email, please check the spam folder',
        'recover_username': 'Recover Username',
        'forgot_user_success_1': 'An email to retrieve the username has been sent',
        'forgot_user_success_2': 'A message was sent to your email',
        'player_without_access': 'The Club you belong to has disabled player\'s access.',
        'playerAccessDisabled': 'The Club you belong to has disabled player\'s access.',
        'clubDisabled': 'The Club and its members have been momentarily blocked.',
        'error_423': 'You have tried to login too many times, which is why your account is temporarily locked. Please try again in {{mins}} minutes.'
      },
      de: {
        'page_title': 'Greife auf dein Konto zu | Oliver Platform',
        'page_description': 'Melden Sie sich mit Ihrem Benutzernamen und Passwort an und messen Sie alle Ihre Metriken der von Ihnen gespielten Spiele. Schöpfen Sie mit OLIVER Ihr volles Potenzial aus.',
        'invalid_user_pass': 'Ungültiger Benutzername oder Passwort',
        'userNotFound': 'Ungültiger Benutzername oder Passwort',
        'reset_max_tries': 'Sie haben die maximale Anzahl an täglichen Versuchen erreicht',
        'reset_not_found': 'Mit den eingegebenen Daten wurde kein Benutzer gefunden',
        'ask_demo': 'Fordern Sie eine Demo an',
        'form_email_username': 'E-Mail / Benutzername',
        'form_password': 'Passwort',
        'have_you_forgot': 'Hast du deine vergessen',
        'form_username': 'Nutzername',
        'form_login': 'Anmeldung',
        'form_accept': 'Akzeptieren',
        'form_email': 'Email',
        'dont_have_account': 'Sie haben kein Konto?',
        'contact_us': 'Kontaktiere uns',
        'reset_password': 'Passwort zurücksetzen',
        'form_reset': 'Zurücksetzen',
        'form_recover': 'Wiederherstellung',
        'forgot_success_1': 'Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet',
        'forgot_success_2': 'Eine Nachricht wurde an Ihre E-Mail-Adresse gesendet',
        'forgot_success_3': 'Folgen Sie den Anweisungen, um das Passwort zurückzusetzen.',
        'forgot_success_4': 'Wenn Sie keine E-Mail erhalten, überprüfen Sie bitte den Spam-Ordner',
        'recover_username': 'Benutzernamen wiederherstellen',
        'forgot_user_success_1': 'Eine E-Mail zum Abrufen des Benutzernamens wurde gesendet',
        'forgot_user_success_2': 'Eine Nachricht wurde an Ihre E-Mail-Adresse gesendet',
        'player_without_access': 'Der Club, dem Sie angehören, hat einen behinderten Zugang für Spieler.',
        'playerAccessDisabled': 'Der Club, dem Sie angehören, hat einen behinderten Zugang für Spieler.',
        'clubDisabled': 'Der Club und seine Mitglieder wurden vorübergehend gesperrt.',
        'error_423': 'Sie haben zu oft versucht, sich anzumelden, weshalb Ihr Konto vorübergehend gesperrt ist. Bitte versuchen Sie es in {{mins}} Minuten erneut.'
      },
      pt: {
        'page_title': 'Acesse sua conta | Oliver Platform',
        'page_description': 'Faça login com seu nome de usuário e senha e meça todas as suas métricas das partidas que você disputou. Obtenha todo o seu potencial com OLIVER.',
        'invalid_user_pass': 'Usuário ou senha incorretos',
        'userNotFound': 'Usuário ou senha incorretos',
        'reset_max_tries': 'Você atingiu o número máximo de tentativas diárias',
        'reset_not_found': 'Nenhum usuário foi encontrado com os dados inseridos',
        'ask_demo': 'solicitar uma demonstração',
        'form_email_username': 'Email / Nome de Usuario',
        'form_password': 'Senha',
        'have_you_forgot': 'Você esqueceu seu',
        'form_username': 'Nome do usuário',
        'form_login': 'Entrar',
        'form_accept': 'Aceitar',
        'form_email': 'Email',
        'dont_have_account': 'Você não tem uma conta?',
        'contact_us': 'Contate-nos',
        'reset_password': 'Redefinir senha',
        'form_reset': 'Redefinir',
        'form_recover': 'Recuperar',
        'forgot_success_1': 'O e-mail de redefinição de senha foi enviado',
        'forgot_success_2': 'Uma mensagem foi enviada para o seu e-mail',
        'forgot_success_3': 'Siga as instruções para redefinir a senha.',
        'forgot_success_4': 'Se você não receber nenhum e-mail, verifique a pasta de spam',
        'recover_username': 'Recuperar Usuário',
        'forgot_user_success_1': 'Um e-mail para recuperar o nome de usuário foi enviado',
        'forgot_user_success_2': 'Uma mensagem foi enviada para o seu e-mail',
        'player_without_access': 'O clube ao qual você pertence desativou o acesso do jogador.',
        'playerAccessDisabled': 'O clube ao qual você pertence desativou o acesso do jogador.',
        'clubDisabled': 'O Clube e seus membros foram momentaneamente bloqueados.',
        'error_423': 'Você tentou fazer login muitas vezes, e é por isso que sua conta está temporariamente bloqueada. Tente novamente em {{mins}} minutos.'
      },
      ja: {
        'page_title': 'アカウントにアクセスする | Oliver Platform',
        'page_description': 'ユーザー名とパスワードでログインし、プレイした試合のすべての指標を測定します。 OLIVER であなたの可能性を最大限に引き出しましょう。',
        "invalid_user_pass": "ユーザー名またはパスワードが無効です",
        "userNotFound": "ユーザー名またはパスワードが無効です",
        "reset_max_tries": "1日の試行回数が上限に達しました。",
        "reset_not_found": "入力されたデータを持つユーザーが見つかりませんでした",
        "ask_demo": "デモを依頼する",
        "form_email_username": "メールアドレス/ユーザー名",
        "form_password": "パスワード",
        "have_you_forgot": "忘れましたか？",
        "form_username": "ユーザ名",
        "form_login": "ログイン",
        "form_accept": "受諾",
        "form_email": "Email",
        "dont_have_account": "アカウントを持っていないですか？",
        "contact_us": "お問合せ",
        "reset_password": "パスワードをリセット",
        "form_reset": "レセット",
        "form_recover": "回復する",
        "forgot_success_1": "パスワードをリセットするためのメールが送信されました",
        "forgot_success_2": "あなたの電子メールにメッセージが送信されました",
        "forgot_success_3": "表示される指示に従って、パスワードを再設定してください。",
        "forgot_success_4": "メールが届かない場合は、迷惑メールフォルダをご確認ください",
        "recover_username": "ユーザー名の回復",
        "forgot_user_success_1": "ユーザー名を取得するための電子メールが送信されました",
        "forgot_user_success_2": "あなたの電子メールにメッセージが送信されました",
        "player_without_access": "あなたが所属するクラブは、障害者用のアクセスがあります。",
        "playerAccessDisabled": "あなたが所属するクラブは、障害者用のアクセスがあります。",
        'clubDisabled': 'クラブとそのメンバーは一時的にブロックされています。',
        'error_423': '何度もログインしようとしたため、アカウントが一時的にロックされました。 {{mins}} 分後にもう一度お試しください。'
      }
    }

    var _t = function(key, replacement) {
      if (replacement) {
        return (translations[userLang][key] || '').replaceAll('{{' + replacement.key + '}}', replacement.value);
      }
      return translations[userLang][key] || '';
    }

    var translatePage = function() {
      $('.translate').each(function(index, elem) {
        var $elem = $(elem);
        $(elem).text(_t($elem.data('t')))
      });

      $('.translate-p').each(function(index, elem) {
        var $elem = $(elem);
        $(elem).attr('placeholder', _t($elem.data('t')))
      });

      $mainBlock.addClass('loaded');

      if (session && session.user) {
        if (session.user.user_name) {
          $user.val(session.user.user_name);
          $forgotPassUser.val(session.user.user_name);
        }
        if (session.user.email) {
          $forgotUserUser.val(session.user.email);
        }
      }
    }

    // if (!!session.token && !!session.user && !!session.user.id) {
    //   window.location.href = backUrl;
    //   return;
    // }

    var $authForm = $('#auth'),
      $pass = $authForm.find('#auth-pass'),
      $user = $authForm.find('#auth-user'),
      $btn = $authForm.find('#btn-login'),
      $errorMsg = $('.error-msg'),
      $forgotPassForm = $('#forgotPass'),
      $forgotPassUser = $forgotPassForm.find('#auth-user'),
      $forgotPassBtn = $forgotPassForm.find('#btn-login'),
      $forgotUserForm = $('#forgotUser'),
      $forgotUserUser = $forgotUserForm.find('#auth-user'),
      $forgotUserBtn = $forgotUserForm.find('#btn-login'),
      $formContent = $('#formContent'),
      $successContent = $('#successContent'),
      $mainBlock = $('.auth-block'),
      msg = session.msg || undefined;

    if (!!msg) {
      $errorMsg.text(msg);
      $errorMsg.addClass('shown');
      ns.localStorage.set('msg', '');
    }

    var userSessionFields = [
      'f_name',
      'l_name',
      'email',
      'type',
      'sub_type',
      'user_name',
      'id',
      'afterLoginState',
      'language',
      'country',
      'birth_date',
      'profileImg',
      'profile_image',
      'profile_image_url',
      'hash',
      'player',
      'clubs',
      'teams',
      'features',
      'terms_cond',
      'settings'
    ];

    var userFilter = function(user) {
      var _user = {};
      userSessionFields.forEach(function(value) {
        if (user[value]) {
          _user[value] = user[value];
        }
      });
      return _user;
    }

    var getIconByTeam = function(tType) {
      switch (tType) {
        case 'REG11':
        case 'FS':
          return 'futbol';
        case 'HOCKEY':
          return 'hockey';
        case 'RUGBY':
        case 'AM-FB':
          return 'rugby'
        case 'BASSQUET':
          return 'basquet'
      }
    }

    var loginSuccess = function(response) {
      var user = userFilter(response.user)
      if (user.type === 'PLAYER' &&
        user.features.indexOf('PLAYER_ACCESS') < 0) {
        $errorMsg.text(_t('player_without_access'));
        $errorMsg.addClass('shown');
        return;
      }

      var icons = [];
      for (var i = 0; i < user.teams.length; i++) {
        icons.push(getIconByTeam(user.teams[i].type));
      }

      // get uniques
      user.icons = icons.filter(function(currentValue, index, arr) {
        return arr.indexOf(currentValue) === index
      });


      ns.localStorage.set('complete', 0);
      ns.localStorage.set('token', response.token);
      ns.localStorage.set('refresh_token', response.refresh_token);
      ns.localStorage.set('user', user);
      ns.localStorage.set('from', 'portal');
      ns.localStorage.remove('ignore');
      window.location.href = backUrl;
    };

    var getMinutes = function(response) {
      var seconds = response.getResponseHeader('retry-after') || 3600;
      return Math.ceil((parseInt(seconds) || 3600) / 60);
    }

    var loginFail = function(response, textStatus, request) {
      $('form').find('input, button').prop('disabled', false);
      if (response.status === 423) {
        $errorMsg.text(_t('error_423', { key: 'mins', value: getMinutes(response) }));
      } else {
        $errorMsg.text(_t(response.responseJSON.error));
        setTimeout(function() {
          $errorMsg.removeClass('shown');
        }, 5000);
      }
      $errorMsg.addClass('shown');
    };

    var forgotSuccess = function(response) {
      $('#emailSent').text(response.email);
      $formContent.animate({
        opacity: 0,
      }, 1000, function() {
        $formContent.css('display', 'none');
        $successContent.css('display', 'block');
        $successContent.animate({
          opacity: 1,
        }, 1000);
      });
      // $formContent.css('display', 'none');

    };

    var forgotFail = function(error) {
      $('form').find('input, button').prop('disabled', false);
      if (error.responseJSON && error.responseJSON.error === 'resetPasswordMaxTries') {
        $errorMsg.text(_t('reset_max_tries'));
      } else {
        $errorMsg.text(_t('reset_not_found'));
      }
      $errorMsg.addClass('shown');
      setTimeout(function() {
        $errorMsg.removeClass('shown');
      }, 5000);
    }

    var always = function() {
      $('form').removeClass('loading');
    };

    var getRecaptchaToken = function(callback) {
      callback();
      // grecaptcha.execute(siteRCKey, { action: 'login' })
      //   .then(function(token) {
      //     callback(token);
      //   });
    }

    var login = function(token) {
      $.post(endpoint + 'login', { user_name: $user.val(), password: $pass.val(), rc_token: token })
        .done(loginSuccess)
        .fail(loginFail)
        .always(always);
    }

    var forgotPass = function(token) {
      $.post(endpoint + 'forgot-password', { email_user_name: $forgotPassUser.val(), rc_token: token })
        .done(forgotSuccess)
        .fail(forgotFail)
        .always(always);
    }

    var forgotUser = function(token) {
      $.post(endpoint + 'forgot-user', { email: $forgotUserUser.val(), rc_token: token })
        .done(forgotSuccess)
        .fail(forgotFail)
        .always(always);
    }

    $authForm.on('submit', function(e) {
      e.preventDefault();

      if ($user.val() !== '' && $pass.val() !== '') {
        $errorMsg.removeClass('shown');
        $(this).addClass('loading');
        $(this).find('input, button').prop('disabled', true);

        getRecaptchaToken(login);
      }
    });

    $forgotPassForm.on('submit', function(e) {
      e.preventDefault();

      if ($forgotPassUser.val() !== '') {
        $errorMsg.removeClass('shown');
        $(this).addClass('loading');
        $(this).find('input, button').prop('disabled', true);

        getRecaptchaToken(forgotPass);
      }
    });

    $forgotUserForm.on('submit', function(e) {
      e.preventDefault();

      if ($forgotUserUser.val() !== '') {
        $errorMsg.removeClass('shown');
        $(this).addClass('loading');
        $(this).find('input, button').prop('disabled', true);

        getRecaptchaToken(forgotUser);
      }
    });

    translatePage();
    $('html').attr('lang', userLang);
  });
})(jQuery);